export const SiteConfig = {
  dashboardBanner: {
    speed: 5000,
    isAutoForward: true,
    images: [
      {
        smallImageUrl: '/assets/images/banners/PP-Members-Banner-B2B-transactaphobia-Web-Mobile-learnmore.jpg',
        largeImageUrl: '/assets/images/banners/PP-Members-banner-B2B-Transactaphobia-Web-Members-learnmore.jpg',
        defaultImageUrl: '/assets/images/banners/PP-Members-banner-B2B-Transactaphobia-Web-Members-learnmore.jpg',
        landingUrl: 'https://upscapital.com/product-services/b2b-secure-payments/',
      },
      // {
      //   smallImageUrl: '/assets/images/banners/hero_small.jpg',
      //   largeImageUrl: '/assets/images/banners/hero_large.jpg',
      // },
      // {
      //   smallImageUrl: '/assets/images/banners/dashboard-banner-jeweler-mobile.jpg',
      //   largeImageUrl: '/assets/images/banners/dashboard-banner-jeweler.jpg',
      //   landingUrl: 'https://www.parcelpro.com',
      // },
    ],
  },
  dashboardAnnouncement: {
    characterLimit: 400,
    lineLimit: 3,
  },
  tableConfig: {
    retrieve: true,
    autoWidth: false,
    searching: false,
    info: false,
    paging: false,
    ordering: false,
    colReorder: false,
    responsive: false,
  },
  shouldAllowShipmentEdit: true,
  reload: {
    polling: {
      enable: true,
      interval: 180000, // 3 mins to test
    },
    idle: {
      enable: true,
      timeout: 3600000,
    },
  },
};
